// Copyright (c) 2017 Deere & Company

import Metric from '../state/metric';
import actions from '../actions-list';
import {getDefaultState} from '../state';
import {updateKeyValueSelectionList} from '../../../shared/services/list-selections';

const selectAllMetrics = state => {

    const toggleSelectedPipMetricsState = state.selectedMetrics.length > 0 ? [] : state.allowedMetrics;

    return Metric.update(state, {
        selectedMetrics: {
            $set: toggleSelectedPipMetricsState
        }
    });

};

const selectMetric = (state, action) =>
    Metric.update(state, {
        selectedMetrics: {
            $set: updateKeyValueSelectionList(action.metric, action.isSelected, state.selectedMetrics)
        }
    });

const updateMetrics = (state, action) =>
    Metric.update(state, {
        allowedMetrics: {
            $set: action.metrics
        },
        selectedMetrics: {
            $set: action.metrics.filter(metric => metric.key === 'Y')
        }
    });

export default (state = getDefaultState().metric, action) => {

    const actionTypes = {
        [actions.RESET_OPEN_PIP_PROGRAMS_REPORT_METRICS]: updateMetrics,
        [actions.SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_PIP_METRICS]: selectAllMetrics,
        [actions.SELECT_OPEN_PIP_PROGRAMS_REPORT_METRIC]: selectMetric,
        [actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_METRICS]: updateMetrics
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/reducers/metric.js